import React, { useEffect, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { fileMaxSize, FindLoad, FindSuccess, Images } from 'utils';
import { SelectInput, ValidationInput } from '../inputs';
import { TextToolTip } from '../toolTip';
import { CloseButton, CreateChancel } from '../buttons';
import { UploadServices } from '../../store/authServices/uplodService';
import { ToastScreen } from '../screens';
import { renderFileTypeSvg } from './constants';
import { httpRequestsOnLoadActions, httpRequestsOnSuccessActions } from 'store';

export const NewDragAndDrop = (
  {
    documentsTypes,
    handleShowUploadedDocs,
    handleUploadFile,
    onlyFormData,
    onlyFile,
    addLoadAction,
    downloadFileImmediately,
    allowUploadFileTypes,
    disabledUpload,
  },
) => {
  const [isHoveredProfile, toggleHoveredProfile] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadedFileType, setUploadedFileType] = useState('');
  const [notes, setNotes] = useState('');
  const [uploadDocError, setUploadFileDocsError] = useState({
    errorForSize: false,
    errorForDontSelect: false,
  });
  const dispatch = useDispatch();
  const addLoader = FindLoad(addLoadAction);
  const addSuccess = FindSuccess(addLoadAction);
  const allowUploadFile = ((file && !uploadDocError.errorForSize)
    || (file && documentsTypes && !uploadedFileType && !uploadDocError.errorForDontSelect && !uploadDocError.errorForSize));

  useEffect(() => {
    if (addSuccess?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(addLoadAction));
      setFile(null);
      setNotes('');
      if (documentsTypes) {
        setUploadFileDocsError({
          errorForSize: false,
          errorForDontSelect: false,
        });
        setUploadedFileType('');
      } else {
        setUploadFileDocsError(prev => ({
          ...prev,
          errorForSize: false,
        }));
      }
    }
  }, [addSuccess]);


  const uploadFile = async (file) => {
    if (allowUploadFileTypes && allowUploadFileTypes?.includes('text/csv') && file?.type !== 'text/csv') {
      return alert('Please upload csv file');
    }

    const name = uploadedFileType ? uploadedFileType : file?.name?.replace(',', '').replace(/\s/g, '').replace('#', '');
    const myNewFile = new File([file], name, { type: file?.type });

    let formData = new FormData();
    formData.append('files', myNewFile);

    if (onlyFormData) {
      handleUploadFile(formData);
    } else if (onlyFile) {
      handleUploadFile(file);
    } else {
      try {
        dispatch(httpRequestsOnLoadActions.appendLoading(addLoadAction));
        const res = await UploadServices.UploadImage(formData);

        const pos = file.type.slice(file.type.search('/'));
        const fileFormat = pos.substring(1);

        const info = {
          file: {
            ...res.data,
            name: file.name,
            originalName: file.name,
            format: fileFormat,
          },

          notes,
        };
        if (documentsTypes) {
          info.type = uploadedFileType;
          info.name = file.name;
        } else {
          info.name = file.name;
        }
        handleUploadFile(info);

      } catch (e) {
        dispatch(httpRequestsOnLoadActions.removeLoading(addLoadAction));
      }
    }
  };

  const handleChangeFile = async (file) => {
    if (documentsTypes && !uploadedFileType) {
      setUploadFileDocsError(prev => ({
        ...prev,
        errorForDontSelect: true,
      }));
    } else {
      if (file?.size > fileMaxSize) {
        if (downloadFileImmediately) {
          toast(<ToastScreen type={'error'} text={'File size must be less than 10MB.'} />);
        }

        setUploadFileDocsError(prev => ({
          ...prev,
          errorForSize: true,
        }));
      } else {
        setUploadFileDocsError(prev => ({
          ...prev,
          errorForSize: false,
        }));

        if (downloadFileImmediately) {
          await uploadFile(file);
        }
      }
      setFile(file);
    }
  };

  const deleteFile = () => {
    setFile(null);
  };

  const handleChangeNote = (e) => {
    setNotes(e?.target?.value);
  };

  const handleChangeUploadedFileTye = (e) => {
    setUploadedFileType(e.target.value);
    setUploadFileDocsError(prev => ({
      ...prev,
      errorForDontSelect: false,
    }));
  };

  const saveDocument = async () => {
    if (allowUploadFile) {
      await uploadFile(file);
    }
  };


  return (
    <div className='new-drag-and-drop-wrapper'>
      <div className='new-drag-and-drop-box'>
        {(file && !downloadFileImmediately) &&
          <div className='uploaded-file-item-wrapper'>
            <ValidationInput
              style='uploaded-file-item-note-wrapper'
              className={`uploaded-file-item-note ${notes ? 'edit-new-doc-notes-fill' : ''}`}
              onChange={handleChangeNote ? handleChangeNote : () => {
              }}
              variant={'outlined'}
              name={'notes'}
              label={'Note'}
              type={'text'}
              multiline
              value={notes}
            />

            <div
              className={`uploaded-file-item-block ${uploadDocError?.errorForSize ? 'uploaded-file-item-block-error' : ''}`}>
              <div className='uploaded-file-item-image-type'>
                <img src={renderFileTypeSvg(file)} alt='new file type' />
              </div>

              <div className='uploaded-file-item-content'>
                <div className='uploaded-file-item-content-header'>
                  <TextToolTip
                    text={file?.name}
                    content={file?.name}
                    classNameText='uploaded-file-item-file-name'
                  />

                  <button
                    className='uploaded-file-item-file-trash'
                    onClick={deleteFile}
                  >
                    <img src={Images.trashIcon} alt='trash' />
                  </button>
                </div>

                <div className='uploaded-file-item-content-body'>
                  <div
                    className='uploaded-file-item-content-body-liner'
                    style={!uploadDocError?.errorForSize ? { background: '#438BFE' } : {}}
                  />
                  {uploadDocError?.errorForSize ?
                    <p className='uploaded-file-item-is-error'>Failed</p>
                    :
                    <div className='uploaded-file-item-is-done-failed'>
                      <div className='uploaded-file-item-is-done'>
                        <img src={Images.CheckboxBase} alt='done' />
                      </div>

                      <p className='uploaded-file-item-is-done-text'>
                        Done
                      </p>
                    </div>
                  }
                </div>

                {uploadDocError?.errorForSize &&
                  <div className='error-text-and-button-for-size'>
                    Error: your document must have less than 10MB size.
                    <span style={{ color: '#2A374E' }}>Please</span>
                    <button
                      className='error-button-for-size'
                      onClick={deleteFile}
                    >
                      Try again.
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <div
          className='new-drag-and-drop-block'
          style={{ background: isHoveredProfile ? '#E4F3FF' : '' }}
          onDragEnter={() => toggleHoveredProfile(true)}
          onDragLeave={() => toggleHoveredProfile(false)}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {(!file && handleShowUploadedDocs) &&
            <div className='new-drag-and-drop-block-close-btn'>
              <CloseButton handleCLic={handleShowUploadedDocs} />
            </div>
          }

          <div className='new-drag-and-drop-block-content-select'>
            <div className='new-drag-and-drop-image'>
              <img src={Images.upload} alt='drag' />
            </div>

            <div className='new-drag-and-drop-choose-file'>
              Drag and Drop or
              <label
                className='new-drag-choose-file-text'
                htmlFor='newFile'
                onClick={e => e.stopPropagation()}
              >
                Choose File
              </label>
            </div>

            <p className='new-drag-and-drop_info'>
              Supported file PDF, PNG, JPG. Max Size 10MB.
            </p>

            {documentsTypes && (
              <SelectInput
                name={'docType'}
                handleSelect={handleChangeUploadedFileTye}
                value={uploadedFileType}
                list={documentsTypes}
                typeError={uploadDocError?.errorForDontSelect ? 'Error: Document type is required.' : ''}
                type={'mc'}
              />
            )}
          </div>

          <FileUploader
            disabled={disabledUpload}
            classes={`new-file-uploader ${isHoveredProfile ? 'new-file-uploader-hover' : ''}`}
            name='newFile'
            handleChange={handleChangeFile}
            // types={['JPG', 'PNG', 'SVG', 'XML', 'PDF']}
            onDraggingStateChange={(isDragging) => {
              toggleHoveredProfile(isDragging);
            }}
            dropMessageStyle={{ display: 'none' }}
            children={<div></div>}
          />
        </div>
      </div>

      {(file && !downloadFileImmediately) &&
        <div className='new-drag-and-drop'>
          <CreateChancel
            disabled={!allowUploadFile}
            loader={!!addLoader?.length}
            create={'Save'}
            chancel={'Cancel'}
            onCreate={saveDocument}
            onClose={() => {
              handleShowUploadedDocs && handleShowUploadedDocs();
            }
            }
            width='93px'
          />
        </div>
      }
    </div>
  );
};